import { ISexSecretData } from 'redhotpie-shared-lib/interfaces/INewFeed';
import * as utils from '../functions/utils';
import { IContentItemSexSecret } from 'redhotpie-shared-lib/interfaces/ICommunity';

export default class SexSecret {
  id: number;
  parrentType: string;
  title: string;
  likeCount: number;
  replyCount: number;
  isMemberLike: boolean;
  imgUrl: string;
  description: string;
  sexSecretType: string | null;
  dateCreated: number | string | undefined;

  constructor() {
    this.id = -1;
    this.parrentType = '';
    this.title = '';
    this.likeCount = 0;
    this.replyCount = 0;
    this.isMemberLike = false;
    this.imgUrl = '';
    this.description = '';
    this.sexSecretType = null;
    this.dateCreated = '';
  }

  static mappingObject(_obj: ISexSecretData): IContentItemSexSecret {
    let obj = Object.assign(new SexSecret(), _obj);
    obj.id = _obj.ID || -1;
    obj.parrentType = _obj.ParentType ? _obj.ParentType : '';
    obj.title = _obj.Title ? _obj.Title : '';
    obj.likeCount = _obj.LikeCount || 0;
    obj.replyCount = _obj.ReplyCount || 0;
    obj.isMemberLike = _obj.IsMemberLike ? _obj.IsMemberLike : false;
    obj.imgUrl = _obj.ImgUrl ? _obj.ImgUrl : '';
    obj.dateCreated = _obj.DateCreated ? _obj.DateCreated : '';
    obj.description = _obj.Description ? _obj.Description : '';
    obj.sexSecretType = _obj.SexSecretType ? _obj.SexSecretType : null;
    obj = utils.cleanObjectKeys(Object.keys(new SexSecret()), obj);

    return obj;
  }

  static mappingObjects(_data: ISexSecretData[]): IContentItemSexSecret[] {
    return _data.map(item => SexSecret.mappingObject(item));
  }
}
